import BaseRepository from './base.repository';

class OnboardingRepository extends BaseRepository {
  constructor() {
    super('/onboarding');
  }

  acceptTerms() {
    return this.client.post('terms', { accepted: true });
  }

  complete(request) {
    return this.client.post('complete', request);
  }
}

export default new OnboardingRepository();
